/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignAclStore } from '../../axios/campaignAclStore'
import type {
	CampaignAclStoreError,
	CampaignAclStorePathParams,
	CampaignAclStoreResponse,
} from '../../types/CampaignAclStore'

export const campaignAclStoreMutationKey = () => [{ url: '/campaigns/:campaign/access/:user' }] as const

export type CampaignAclStoreMutationKey = ReturnType<typeof campaignAclStoreMutationKey>

export type CampaignAclStoreVariables = {
	campaign: CampaignAclStorePathParams['campaign']
	user: CampaignAclStorePathParams['user']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::store */
export function useCampaignAclStore<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignAclStoreResponse,
		AxiosError<CampaignAclStoreError>,
		CampaignAclStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignAclStoreMutationKey(),
		mutationFn: ({ campaign, user }: CampaignAclStoreVariables) =>
			campaignAclStore(campaign, user, config).then(res => res.data),
		...options,
	})
}
